import { inject, injectable } from 'inversify';
import type { AxiosResponse } from 'axios';
import { HostDependencyTypes } from '@shared/common/host/host.dependency-types';
import type { HubApiService } from '@shared/common/host/data/service/hub.api-service';
import type { ClientSeasonApiData } from '@client/entity/client-season/data/api-data/client-season.api-data';
import { ClientSeasonApiRoute } from '@client/entity/client-season/data/constant/client-season.api-routes';

@injectable()
export class ClientSeasonApiService {
  public constructor(
    @inject(HostDependencyTypes.HubApiService)
    private readonly hubApiService: HubApiService,
  ) {}

  public getClientSeason(clientId: string): Promise<AxiosResponse<ClientSeasonApiData>> {
    return this.hubApiService.get<ClientSeasonApiData>(ClientSeasonApiRoute.GetClientSeason(clientId), {
      headers: {
        Accept: 'application/json',
      },
    });
  }
}
